import api from './index';

const base = '/document-project';

export interface ProjectListModel {
    id: number;
    name: string;
}

export interface DocumentProjectFileModel {
    id: number;
    propertyAssetId: number;
    title: string;
    kind: 'pdf' | 'spreadsheet';
    sortOrder: number;
    blobUrl: string;
    viewerUrl: string;
}

export const createProject = (name: string): Promise<ProjectListModel> =>
    api.post<ProjectListModel>(`${base}/projects`, { name }).then((r) => r.data);

export const getMyProjects = (): Promise<ProjectListModel[]> =>
    api.get<ProjectListModel[]>(`${base}/my-projects`).then((r) => r.data);

export const getAllProjects = (): Promise<ProjectListModel[]> =>
    api.get<ProjectListModel[]>(`${base}/projects`).then((r) => r.data);

export const getProjectFiles = (propertyAssetId: number): Promise<DocumentProjectFileModel[]> =>
    api.get<DocumentProjectFileModel[]>(`${base}/${propertyAssetId}/files`).then((r) => r.data);

export const uploadProjectFile = (propertyAssetId: number, title: string, kind: string, file: File): Promise<DocumentProjectFileModel> => {
    const form = new FormData();
    form.append('title', title);
    form.append('kind', kind);
    form.append('file', file);
    return api.post<DocumentProjectFileModel>(`${base}/${propertyAssetId}/files`, form).then((r) => r.data);
};

export const updateProjectFile = (fileId: number, title: string, kind: string, file?: File | null): Promise<DocumentProjectFileModel> => {
    const form = new FormData();
    form.append('title', title);
    form.append('kind', kind);
    if (file) form.append('file', file);
    return api.put<DocumentProjectFileModel>(`${base}/files/${fileId}`, form).then((r) => r.data);
};

export const deleteProjectFile = (fileId: number): Promise<void> =>
    api.delete(`${base}/files/${fileId}`).then(() => undefined);

export const deleteProject = (projectId: number): Promise<void> =>
    api.delete(`${base}/projects/${projectId}`).then(() => undefined);

export const getFileViewUrl = (fileId: number): Promise<string> =>
    api.get<string>(`${base}/files/${fileId}/view-url`).then((r) => r.data);

/** Streams spreadsheet bytes through the API (avoids browser CORS to Azure Blob on SAS URL). */
export const downloadSpreadsheetFile = (fileId: number): Promise<Blob> =>
    api.get<Blob>(`${base}/files/${fileId}/download`, { responseType: 'blob' }).then((r) => r.data);

export const getCompanyProjectAccess = (companyId: number): Promise<number[]> =>
    api.get<number[]>(`${base}/company-access/${companyId}`).then((r) => r.data);

export const setCompanyProjectAccess = (companyId: number, propertyAssetIds: number[]): Promise<void> =>
    api.put(`${base}/company-access/${companyId}`, propertyAssetIds).then(() => undefined);
